import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import Tabs from '../Tabs/Tabs';
import SuperAdminAmenityBuilderWorkspace from "./SuperAdminAmenityBuilderWorkspace";
import SuperAdminAmenityBuilderErrors from "./SuperAdminAmenityBuilderErrors"

class SuperAdminAmenityBuilder extends React.Component{

  constructor(props) {
    super(props);

    this.state = {
      active_tab: 'general',
      is_new: this.props.is_new,
      loading: false,
      errors: this.props.errors || {},
      amenity: this.props.amenity || {},
      all_ru_amenities: this.props.all_ru_amenities || [],
      all_amenities: this.props.all_amenities || [],
      amenity_create_path: this.props.amenity_create_path,
      amenity_save_path: this.props.amenity_save_path,
      order: []
    }

    this.setActiveTab = this.setActiveTab.bind(this)
    this.onChangeRUAmenities = this.onChangeRUAmenities.bind(this)
    this.onChangeField = this.onChangeField.bind(this)
    this.onChangeOrder= this.onChangeOrder.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  render() {
    var buttons = [
      {
        name: I18n.t('cancel'),
        html_attributes: ['data-dismiss="modal"']
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary'],
        onClick: this.onSubmit,
      },
    ]

    return (
      <div className="SuperAdminAmenityBuilder">
        <Tabs tabs={this.tabs()} />
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons} displayErrorMessage={(SuperAdminAmenityBuilderErrors.general(this.state.errors).length) ? true : false}/>
          <SuperAdminAmenityBuilderWorkspace
            {...this.state}
            onChangeRUAmenities={this.onChangeRUAmenities}
            onChangeField={this.onChangeField}
            onChangeOrder={this.onChangeOrder} />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  tabs() {
    
    return (
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.setActiveTab,
          tabErrorCount: SuperAdminAmenityBuilderErrors.general(this.state.errors).length
        },
        {
          tabName: I18n.t('ru_amenities'),
          targetName: 'ru_amenities',
          classes: this.state.active_tab === 'ru-amenities' ? 'active' : null,
          changeHandler: this.setActiveTab,
        },
      ]
    );
  };

  onSubmit(){
    var self = this
    self.setState({ loading: true })
    
    setTimeout(function () {
      $.ajax({
        type: 'POST',
        url: self.state.amenity_save_path,
        data: {
          amenity: self.state.amenity,
          order: self.state.order,
          ru_amenity_ids: self.state.amenity.ru_amenities.map((a) => a.id)
        }
      }).done(function (data) {
        if(Object.keys(data.errors).length){
          self.setState({
            errors: data.errors,
            loading: false
          })
        }
        else {
          if (parent && parent.refresh_data) {
            if (self.props.is_new == true) {
              parent.refresh_data(I18n.t('amenity_created_successfully'));
            } else {
              parent.refresh_data(I18n.t('amenity_saved_successfully'));
            }
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal()
          }
        }
      })
    }, 1000)
  }

  renderFieldErrors(object, field) {
    if (object && object.errors && object.errors[field]) {
      var idx = 0;
      var errors = object.errors[field].map( (error) => {
        idx = idx + 1;
        return <li key={idx}><b>&#x2022;</b> {error}</li>;
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  setActiveTab(name) {
    this.setState({active_tab: name})
  }

  onChangeRUAmenities(ru_amenities) {
    var amenity = {...this.state.amenity}
    
    if (ru_amenities != null) {
      ru_amenities.map(ru_amenity => {
        amenity.ru_amenities.push({id: ru_amenity.id, name: ru_amenity.text})
      })

      this.setState({amenity: amenity})
    }
  }

  onChangeOrder(idsInOrder) {
    this.setState({order:idsInOrder})
  }

  onChangeField(event) {
    var amenity = {...this.state.amenity}
    amenity[event.target.name] = event.target.value
    this.setState({
      amenity: amenity
    })
  }

}

export default SuperAdminAmenityBuilder
